/**
 * SVG noise texture overlay — eliminates the flat digital look.
 * Uses an inline SVG turbulence filter for performance.
 */
export default function NoiseOverlay() {
  return (
    <div
      className="pointer-events-none fixed inset-0 z-[60]"
      style={{ mixBlendMode: "overlay", opacity: 0.03 }}
    >
      <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
        <filter id="noise">
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.80"
            numOctaves="4"
            stitchTiles="stitch"
          />
        </filter>
        <rect width="100%" height="100%" filter="url(#noise)" />
      </svg>
    </div>
  );
}
